export default __webpack_public_path__ + "static/media/signin.454f944b.svg";